
// Components
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { DesignAttributeType, OptionsAttribute } from '../../../../types/designer-attribute-type';
import { Component, ElementRef } from '@angular/core';
@Component({
    selector: 'sx-fileimport-designer',
    templateUrl: './fileImport.designer.component.html'
})
export class SxFileImportDesigner extends BaseDesignerComponent {

    constructor(container: ElementRef) {
        super(container, 'SxFileImport');
      }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.title = '';
        this.controlContext.label = 'IMG';
        this.controlContext.types = '';
        this.controlContext.maxSize = '2';
        this.controlContext.sizeMess = '';
        this.controlContext.required = false;
        this.controlContext.validationGroup = '';
        this.controlContext.multiple = false;
        this.controlContext.maxFiles = '2';
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();

        info['title'] = this.controlContext.title;
        info['label'] = this.controlContext.label;
        info['types'] = this.controlContext.types;
        info['maxSize'] = this.controlContext.maxSize;
        info['sizeMess'] = this.controlContext.sizeMess;
        info['required'] = this.controlContext.required;
        info['validationGroup'] = this.controlContext.validationGroup;
        info['multiple'] = this.controlContext.multiple;
        info['maxFiles'] = this.controlContext.maxFiles;
        return info;
    }

    buildAttributes(): void {
        super.buildAttributes();

        const titleAtt = new DesignAttributeType(this.controlContext, 'string', 'title', 'TITLE');
        const label = new DesignAttributeType(this.controlContext, 'string', 'label', 'IDENTIFIER');
        const types = new DesignAttributeType(this.controlContext, 'string', 'types', 'ACCEPTED_TYPES');
        const maxSize = new DesignAttributeType(this.controlContext, 'string', 'maxSize', 'FILE_MAX_SIZE');
        const sizeMess = new DesignAttributeType(this.controlContext, 'string', 'sizeMess', 'SIZE_VALIDATION_MESSAGE');
        const required = new DesignAttributeType(this.controlContext, 'boolean', 'required', 'REQUIRED');
        const validationGroup = new DesignAttributeType(this.controlContext, 'string', 'validationGroup', 'VALIDATOR_GROUPS');
        const multiple = new DesignAttributeType(this.controlContext, 'boolean', 'multiple', 'MULTIPLE_FILES');

        //Array of numbers starting from number 2
        const options = Array.from({length: 10}, (_, i) => {
            const number = i + 1;
            return {
                id: number,
                name: number
            }
        }).slice(1);
        const maxFiles = new OptionsAttribute(this.controlContext, options, 'maxFiles', 'MAXIMUN_FILEZS');
        maxFiles.hiddenConditions = [['multiple', '!=', true]];
        this.attributes.push(titleAtt, label, types, maxSize, sizeMess, required, validationGroup, multiple, maxFiles);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/files-manager/fileImport.designer.component.ts